export function LoadingState() {
	return (
		<div
			className="page-container"
			data-test-id="launch-config-page-container"
		>
			<div className="page-inner" data-test-id="launch-config-page-inner">
				<div
					className="flex items-center justify-center h-64"
					data-test-id="loading-wrapper"
				>
					<div
						className="text-lg text-gray-600"
						data-test-id="loading-launch-config"
					>
						Loading launch configuration...
					</div>
				</div>
			</div>
		</div>
	)
}

